export function isSettingField(obj: any): boolean {
  return obj && obj.isSettingField;
}
